import { motion, Variants, easeOut } from "framer-motion";

const araraVariants: Variants = {
    hidden: { opacity: 0, y: 100 },
    visible: {
        opacity: 1,
        y: 0,
        transition: { duration: 1, ease: easeOut },
    },
};

const slideInRightVariants: Variants = {
    hidden: { opacity: 0, x: 100 },
    visible: {
        opacity: 1,
        x: 0,
        transition: { duration: 1, ease: easeOut },
    },
};

const fadeInSlowVariants: Variants = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: { duration: 3, ease: easeOut },
    },
};

export const Footer = () => {
    return (
        <footer className="relative bg-white overflow-hidden">
            <motion.img
                src="/img/arara-pe.png"
                alt="Arara"
                className="hidden md:block
                  absolute bottom-0 left-0 z-30 pointer-events-none max-h-[650px]
                  lg:max-h-[40rem]
                  md:max-h-[450px]
                  2xl:max-h-[650px]"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}
                variants={araraVariants}
            />
            <div id="contato" className="relative z-20">
                <section
                    className="bg-[#F0FDF4] px-6 py-16 md:py-28"
                >
                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.3 }}
                        variants={slideInRightVariants}
                        className="mx-auto text-center">
                        <h2 className="text-2xl md:text-3xl font-semibold text-gray-900 mb-4">
                            Fique por dentro das novidades
                        </h2>
                        <p className="text-gray-700 mb-6">
                            Cadastre seu e-mail e WhatsApp para receber:
                        </p>

                        <div className="flex flex-col md:flex-row gap-4 md:gap-2 justify-center max-w-2xl mx-auto">
                            <input
                                type="email"
                                placeholder="Insira seu e-mail"
                                className="px-4 py-3 rounded-full border border-gray-300 w-full md:w-1/2 focus:outline-none"
                            />
                            <input
                                type="text"
                                placeholder="Insira seu whatsapp"
                                className="px-4 py-3 rounded-full border border-gray-300 w-full md:w-1/2 focus:outline-none"
                            />
                        </div>
                        <button className="mt-6 bg-green-600 hover:bg-green-700 text-white font-medium py-3 px-8 rounded-full transition">
                            Quero receber as novidades
                        </button>
                    </motion.div>
                </section>
                <section className="bg-green-600 text-white px-6 pt-12 pb-[340px] md:py-12 md:pl-[350px] lg:pl-[250px] md:relative">
                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.3 }}
                        variants={fadeInSlowVariants}
                        className=" mx-auto flex flex-col md:flex-row justify-between items-start md:items-center gap-10">
                        <div className="hidden md:block" />

                        <div>
                            <h3 className="font-semibold mb-2 text-4xl">Fale Conosco</h3>
                            <p className="mb-4 text-green-300 text-lg">
                                Estamos à disposição para atendê-lo, tirar dúvidas e receber pedidos.
                            </p>
                        </div>

                        <div className="text-sm space-y-2">
                            {[
                                {
                                    label: "Telefone:",
                                    icon: "/img/fone-logo.png",
                                    value: "(47) 3842-0677",
                                },
                                {
                                    label: "WhatsApp:",
                                    icon: "/img/cel-logo.png",
                                    value: "(47) 9 9932-0627",
                                },
                                {
                                    label: "E-mail:",
                                    icon: "/img/mail-logo.png",
                                    value: "vendas@anilhasalianca.com.br",
                                },
                                {
                                    label: "Instagram:",
                                    icon: "/img/insta-logo.png",
                                    value: "@anilhasalianca",
                                },
                            ].map((item, i) => (
                                <p key={i} className="flex items-center gap-2">
                                    <span className="font-semibold inline-flex items-center gap-2">
                                        <img src={item.icon} alt="" className="w-4 h-4" />
                                        {item.label}
                                    </span>
                                    <span className="text-green-300 whitespace-nowrap">{item.value}</span>
                                </p>
                            ))}
                            <p className="mb-4 text-green-300">
                                Siga nossas redes sociais e acompanhe as novidades da Empresa.
                            </p>
                        </div>
                    </motion.div>
                    <div className="block md:hidden">
                        <img
                            src="/img/arara-pe.png"
                            alt="Arara"
                            className="absolute bottom-[-30px] left-0 max-h-[350px] z-10 pointer-events-none"
                        />
                        <div className="absolute bottom-4 right-4 z-20 text-right w-60">
                            <p className="text-sm text-green-300">
                                © 2025 Anilhas Aliança. Todos os direitos reservados.
                            </p>
                        </div>
                    </div>
                </section>
            </div>
        </footer>
    );
};
